<ng-template
  #tagCell
  let-tag
>
  <proffeo-tag [tag]="tag" />
</ng-template>

<proffeo-ui-table
  (actionClick)="onTableAction($event)"
  [columns]="columns()"
  [emptyText]="'placeholders.no-results-found' | translate"
  [rowActions]="rowActions()"
  [rowId]="resolveRowId"
  [rows]="tags()"
  [tableAriaLabel]="'project-tags.list-headers.tag' | translate"
  orderMode="none"
  class="w-full"
/>
